import { render, staticRenderFns } from "./CreateData.vue?vue&type=template&id=aadb75d4&scoped=true"
import script from "./CreateData.vue?vue&type=script&lang=js"
export * from "./CreateData.vue?vue&type=script&lang=js"
import style0 from "./CreateData.vue?vue&type=style&index=0&id=aadb75d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadb75d4",
  null
  
)

export default component.exports